module.exports = "/_next/static/images/404-3e8258aea2d6ffe65ccaba9901864a98.png";